<template>
  <b-tooltip label="Editar datos de la cama" type="is-dark">
    <b-button type="is-primary" size="is-small" @click="openModal" icon-left="pen-square"></b-button>
  </b-tooltip>

</template>
<script>
  import ModalEditBed from "./ModalEditBed";
  export default {
    props: ['bed','manteiner', 'changeVentilator'],
    methods: {
      openModal() {
        this.$buefy.modal.open({
          parent: this,
          component: ModalEditBed,
          props: {
            bed: this.bed,
            manteiner:this.manteiner,
            changeVentilator: this.changeVentilator
          },
          hasModalCard: true,
          trapFocus: true,
        });
      },
    },
  };
</script>